"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.formatAxisPrice = formatAxisPrice;
function formatAxisPrice(val) {
  const num = Number(val);
  if (isNaN(num)) {
    return String(val);
  }
  const absNum = Math.abs(num);
  let formatted;
  if (absNum >= 1e6) {
    formatted = (num / 1e6).toFixed(1).replace(/\.0$/, '') + 'm';
  } else if (absNum >= 1e3) {
    formatted = (num / 1e3).toFixed(1).replace(/\.0$/, '') + 'k';
  } else {
    formatted = num.toString();
  }
  return formatted;
}